import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const ProjectList = Scrivito.provideObjClass("ProjectList", {
  attributes: {
    createNewProject: "string",
    redirectToProjectCreate: ["reference", { only: "ProjectConfigurator" }],
    redirectToProjectItem: ["reference", { only: "ProjectItem" }],
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
});

export default ProjectList;
